import { IApplicationState } from '../../types/redux';
import { getCurrentTab } from '../tabs';
import { ETabs } from '../../types/redux/tabs';
import { isEmpty } from 'ramda';

export function getRealtorsItems(state: IApplicationState) {
  return state.realtors.listing.items;
}

export function getAgenciesItems(state: IApplicationState) {
  return state.agencies.listing.items;
}

export function hasNotItems(state: IApplicationState) {
  const currentTab = getCurrentTab(state);

  const items = currentTab === ETabs.Realtors ? getRealtorsItems(state) : getAgenciesItems(state);

  return isEmpty(items);
}
